import { API } from "aws-amplify";
export const GetAllProblemDescrtions = {
  data() {
    return {
      overlay: false,
      noDataText: "",
      GetAllProblemDescrtionsList: [],
    };
  },
  methods: {
    async GetAllProblemDescrtionsMethod() {
      const path = "list_customer_categories";
      const myInit = {
        body: {
          command: "list_customer_categories",
          organization_id:
            this.get_Current_Organization_DetailsObject.organization_id,
          setting_status: "ACTIVE",
          setting_type: 'PROBLEM_DESCRIPTION',
        },
      };
      API.post("SERVICEWRK", path, myInit)
        .then((response) => {
          if (!response.errorType) {
            this.GetAllProblemDescrtionsList = response.data.items;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
